'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _slicedToArray = function () { function sliceIterator(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"]) _i["return"](); } finally { if (_d) throw _e; } } return _arr; } return function (arr, i) { if (Array.isArray(arr)) { return arr; } else if (Symbol.iterator in Object(arr)) { return sliceIterator(arr, i); } else { throw new TypeError("Invalid attempt to destructure non-iterable instance"); } }; }();

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _ngRedux = require('ng-redux');

var _ngRedux2 = _interopRequireDefault(_ngRedux);

var _styles = require('./styles.scss');

var _styles2 = _interopRequireDefault(_styles);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var CompetitorCompetitionReportController = function () {
  function CompetitorCompetitionReportController($q, feis, $ngRedux, fRouterHistoryService, msgService, fCSVReportsService, fRegistrationService, fFeisService) {
    var _this = this;

    _classCallCheck(this, CompetitorCompetitionReportController);

    this.$q = $q;
    this.fRouterHistoryService = fRouterHistoryService;
    this.$ngRedux = $ngRedux;
    this.msgService = msgService;
    this.fCSVReportsService = fCSVReportsService;
    this.feis = feis;
    this._feis = fFeisService;
    this._reg = fRegistrationService.for(feis.id);

    // required fields:
    // competitor #, p.fname, p.lname, dob, acct.email, acct.fname, acct.lname, school.name, e.name, e.age, e.level, e.event
    this.headers = ['Competitor', 'First name', 'Last name', 'DOB', 'Account email', 'Account fname', 'Account lname', 'School name', 'Event name', 'Event age', 'Event level', 'Event'];

    this.$q.all([this._reg.all(), this._feis.accounts(this.feis.id)]).then(function (_ref) {
      var _ref2 = _slicedToArray(_ref, 2),
          registrations = _ref2[0],
          accounts = _ref2[1];

      registrations.forEach(function (p) {
        p.account = accounts.find(function (a) {
          return a.id === p.account_id;
        });
      });
      _this.participants = registrations;

      _this.participants.forEach(function (p) {
        p.registrations.sort(function (a, b) {
          return parseInt(a.event.name.match(/^\d+/)[0], 10) - parseInt(b.event.name.match(/^\d+/)[0], 10);
        });
      });
    });
  }

  _createClass(CompetitorCompetitionReportController, [{
    key: 'back',
    value: function back() {
      this.fRouterHistoryService.back();
    }
  }, {
    key: 'generateExcelReport',
    value: function generateExcelReport() {
      var csv = [];
      csv.push(this.headers);

      this.participants.forEach(function (p) {
        p.registrations.sort(function (a, b) {
          return a.event.name.localeCompare(b.event.name);
        });
        p.registrations.forEach(function (r) {
          csv.push([p.competitor, p.fname, p.lname, p.dob, p.account.email, p.account.fname, p.account.lname, p.school.name, r.event.name, r.event.age, r.event.level, r.event.event]);
        });
      });

      this.fCSVReportsService.prepareCSV(csv, this.feis.slug + '_Competitor_Competition.csv');
    }
  }]);

  return CompetitorCompetitionReportController;
}();

exports.default = angular.module('ifeis.routes.feiseanna.one.admin.reports.competitor-competition-report', []).config(function ($stateProvider) {
  $stateProvider.state('feiseanna.one.admin.reports.competitor-competition-report', {
    url: '/competitor-competition-report',
    template: require('./tpl.html'),
    controller: CompetitorCompetitionReportController,
    controllerAs: 'ctrl'
  });
});


//////////////////
// WEBPACK FOOTER
// ./routes/feiseanna/one/admin/reports/competitor-competition/index.js
// module id = 560
// module chunks = 0